// --
// @ts-ignore
import React from "react";
// @ts-ignore
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {authActions, Icon, layout, modal, NavIconText, utils} from "@mc/mc-legacy";
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";
import {withRouter} from "react-router";
import {LinkContainer} from "react-router-bootstrap";
import {OAplikaci} from "../components/OAplikaci";
import {setUserLogout} from "../actions/logoutStatusActions";
import QSignAdminApi from "../api/gen/qsign/QSignAdminApi";
import EAdminAccessRoleTyp from "../api/gen/qsign/types/EAdminAccessRoleTyp";
import AdminAccessRoleVO from "../api/gen/qsign/types/AdminAccessRoleVO";

/**
 * Wrapper pro stránky aplikace.
 */

class AppWrapper extends React.Component {
    static propTypes = {
        appName: PropTypes.oneOfType([
            // název aplikace, který se zobrazuje jako brand, mu6e se jednat i o název globální logické sekce, např. skprávní řízení apod.
            PropTypes.array,
            PropTypes.node,
        ]),
        detail: PropTypes.oneOfType([
            // detail informace aplikace, např. text detailu stránky, globální filtr stránky atp.
            PropTypes.array,
            PropTypes.node,
        ]),
        homeLink: PropTypes.oneOfType([
            PropTypes.func, // pokud je uvedeno, volá se tento callback při klinutí
            PropTypes.string, // přesouvá se na uvedenou url - url pro router
        ]),
        views: PropTypes.array,
        // seznam objektů { name: "", route: "/xxx" }, které představují jednotlivé pohledy v aplikaci
        userMenuAddons: PropTypes.array,
        // pole dalších tlačítek do menu pod uživatelem, typicky pole DropdownItem
        currentView: PropTypes.string,
        // aktuálně přepnutý pohled - route
        backButtonIcon: PropTypes.bool,
        // má se místo loga aplikace zobrazit back button?
        goBack: PropTypes.bool,
        // pokud je true, je kliknutí na brand bráno jako back
        goBackBase: PropTypes.string,
        // základní url, která reprezentuje základ aktuálně zobrazované stránky - při stisku back se půjde na první, která namá prefix uvedený v goBackBase
        hasLeftPanel: PropTypes.bool,
        // aplikace má levý panel, jedná se o případný zasouvací panel
        hasRightPanel: PropTypes.bool,
        // aplikace má pravý panel, jedná se o případný zasouvací panel
        leftPanelCollapsed: PropTypes.bool,
        // pokud je true, je levý panel změnšen a není dokován
        rightPanelCollapsed: PropTypes.bool,
        // pokud je true, je pravý panel změnšen a není dokován
        hideCenterAddons: PropTypes.bool, // pokud je true, nezobrazí se komponenty ve středové části hlavičky (momentálně fulltext field)
    };
    static defaultProps = {
        appName: "QSign",
        backButtonIcon: false,
        views: [],
        currentView: "",
        goBack: false,
        hasLeftPanel: false,
        hasRightPanel: false,
        leftPanelCollapsed: false,
        rightPanelCollapsed: false,
        hideCenterAddons: false,
    };
    // componentDidMount() {
    //     this.fetchData(this.props, false);
    // }

    handleLogout = () => {
        this.props.dispatch(setUserLogout());
        this.props.dispatch(authActions.logout());
    };
    historyGoBackCall = (n) => {
        this.props.history.go(-n);
    };
    handleHistoryGoBack = (goBackBase, homeLink) => {
        if (goBackBase) {
            // jdeme na nejbližší, která NEBUDE mít goBackBase
            let i = window.appHistory.length - 1;
            let found = false;

            while (i >= 0) {
                if (window.appHistory[i].substring(0, goBackBase.length) !== goBackBase) {
                    // Pokud se liší první, který je v historii, přeskočíme ho, protože by se při back nic nestalo
                    const size = window.appHistory.length - i - 1;

                    if (size > 0) {
                        found = true;
                        this.historyGoBackCall(size);
                        break;
                    }
                }

                i--;
            }

            // Jdeme na homeLink
            if (!found) {
                if (typeof homeLink === "function") {
                    homeLink();
                } else {
                    this.props.history.push(homeLink);
                }
            }
        } else {
            this.props.history.goBack();
        }
    };
    showOAplikaci = () => {
        this.props.dispatch(
            modal.ModalActions.show(OAplikaci, {}, "O aplikaci", {
                size: "md",
            })
        );
    };
    renderViewMenuItem = (v, i) => {
        const {currentView, authInfo} = this.props;
        const items = [];
        let subViewCount = 0;

        if (v.subViewGenerator) {
            const result = v.subViewGenerator(authInfo.data);
            subViewCount = result.length;

            if (subViewCount > 0) {
                items.push(<DropdownItem divider/>);
                items.push(<DropdownItem header>{v.name}</DropdownItem>);
                items.push(result.map((v, i) => this.renderViewMenuItem(v, i * 10)));
                items.push(<DropdownItem divider/>);
            }
        }

        if (subViewCount === 0) {
            items.push(
                <LinkContainer to={v.route} key={i} exact>
                    <DropdownItem
                        /*className={currentView === v.route ? "active" : ""}*/
                    >
                        {v.name}
                    </DropdownItem>
                </LinkContainer>
            );
        }

        return items;
    };
    handleServis = () => {
        this.props.history.push("/administrace/sablony");
    };

    private createAccessAdminButton(adminAccessData : AdminAccessRoleVO) : JSX.Element | null {
        if (adminAccessData.adminAccessRoleTyp == null) {
            console.error("authInfo.data obsahuje adminAccessData, ale jeho field adminAccessRoleTyp je null. Nevalidní stav!");
            return null;
        }
        // @ts-ignore
        return <DropdownItem key="adminAccessBtn" onClick={this.handleAdminAccessSwitch}>
            {adminAccessData.adminAccessRoleTyp === EAdminAccessRoleTyp.ROLE_ADMIN ? "Režim uživatel" : "Režim admin"}
        </DropdownItem>;
    }

    handleAdminAccessSwitch = async () : Promise<void> => {
        const adminAccessData : AdminAccessRoleVO = this.props.authInfo?.data?.adminAccessData;
        if (!adminAccessData || !adminAccessData.adminAccessRoleTyp) {
            console.error("Nevalidní přístup na změnu admin práv. Uživatel nemá přístup access admin.")
            return;
        }
        const adminAccessDataOpacnaRole = _createOpacnaRole(adminAccessData);
        await QSignAdminApi.setAdminAccessRole(adminAccessDataOpacnaRole);
        this.props.dispatch(authActions.invalidate(null)); //dotáhnutí nového auth ze serveru
        this.props.history.push("/");

        function _createOpacnaRole(acr : AdminAccessRoleVO) : AdminAccessRoleVO {
            const acrOpacna = acr;
            acrOpacna.adminAccessRoleTyp = acr.adminAccessRoleTyp == EAdminAccessRoleTyp.ROLE_ADMIN ?
                    EAdminAccessRoleTyp.ROLE_UZIVATEL : EAdminAccessRoleTyp.ROLE_ADMIN;
            return acrOpacna;
        }
    }

    render() {
        const {userMenuAddons, views, authInfo, hideCenterAddons, ...other} = this.props;
        const authStatus = authInfo.data;
        // Usermenu
        const appUserMenuAddons = [];

        if (userMenuAddons) {
            appUserMenuAddons.push(...userMenuAddons);
        }

        // --
        if (authStatus.admin) {
            appUserMenuAddons.push(
                <DropdownItem key="administrace" onClick={this.handleServis}>
                    Administrace
                </DropdownItem>
            );
        }

        //Tlačítko na změnu práv. Pokud není nastaven adminAccessData (viz.:AppWrapper#mapStateToProps, tlačítko se vůbec nezobrazí)
        if (authStatus.adminAccessAllowed) {
            const prepnoutPravaBtn : (JSX.Element | null) = this.createAccessAdminButton(authStatus.adminAccessData);
            if (prepnoutPravaBtn !== null) {
                appUserMenuAddons.push(prepnoutPravaBtn);
            }
        }

        const collapseAddons = [];
        collapseAddons.push(
            <UncontrolledDropdown nav key="help" id="help">
                <DropdownToggle nav className="icon-text">
                    <NavIconText icon={<Icon icon="question-circle"/>}/>
                </DropdownToggle>
                <DropdownMenu right>
                    <DropdownItem href={`${serverContextPath}/napoveda`} target="blank">
                        Nápověda
                    </DropdownItem>
                    <DropdownItem onClick={this.showOAplikaci}>O aplikaci</DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        );

        // Pohledy
        if (views && views.length > 0) {
            collapseAddons.push(
                <UncontrolledDropdown nav key="areas" id="areas">
                    <DropdownToggle nav className="icon-text">
                        <NavIconText icon={<Icon icon="th"/>} text={"Pohled"}/>
                    </DropdownToggle>
                    <DropdownMenu right>{views.map((v, i) => this.renderViewMenuItem(v, i))}</DropdownMenu>
                </UncontrolledDropdown>
            );
        }

        // Render
        return (
            // @ts-ignore
            <layout.BaseAppWrapper
                {...other}
                appCode="qsign"
                onHistoryGoBack={this.handleHistoryGoBack} //centerAddons={false}
                onLogout={this.handleLogout}
                collapseAddons={collapseAddons}
                userMenuAddons={appUserMenuAddons}
                authStatus={authStatus}
                testEnvironment={testEnvironment}
            />
        );
    }
}


function mapStateToProps(state) {
    const authInfo = utils.storeFromArea(state, authActions.AUTH_INFO_AREA);
    const authInfoCpy = JSON.parse(JSON.stringify(authInfo));
    if (authInfoCpy.data.adminAccessAllowed === true) {
        authInfoCpy.data.adminAccessData = {
            adminAccessRoleTyp : (authInfoCpy.data.admin === true) ? EAdminAccessRoleTyp.ROLE_ADMIN : EAdminAccessRoleTyp.ROLE_UZIVATEL
        };
        console.log("admin ", authInfoCpy.data.admin, " adminAccessRoleTyp ", authInfoCpy.data.adminAccessData.adminAccessRoleTyp);
    }
    return {
        authInfo: authInfoCpy,
    };
}

// @ts-ignore
export default withRouter(connect(mapStateToProps)(AppWrapper));
